import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { validateForm } from "src/app/shared/validators";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveydate",
    styleUrls: ["./common.css"],
    template: `<ng-container
      ><mat-form-field appearance="fill" floatLabel="always">
      <mat-label>{{ props.question?.identifierText || 'Choose' }}</mat-label>
      <input
        matInput
        class="form-field"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.isRequired"
        [min]="props.question.options[0].value"
        [max]="props.question.options[1].value"
        [matDatepicker]="picker"
        [disabled]="props.disabled"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint class="error" align="start">{{
          getErrorMessage(props.question?.id)
        }}</mat-hint>
      </mat-form-field>
      @if (props.question?.showCommentBox) {
        <br />
        <mat-form-field appearance="fill" floatLabel="always" class="comments">
          <mat-label>Comments</mat-label>
          <textarea
            [id]="props.question?.id + '-comments'"
            [ngModel]="commentModel"
            rows="4"
            class="form-field"
            matInput
            (blur)="onBlurEvent($event)"
            [disabled]="props.disabled"
          ></textarea>
        </mat-form-field>
      }
    </ng-container>`,
    standalone: false
})
export class FormlyFieldSurveyDateComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public commentModel: string;
  commentKey: string;

  getErrorMessage(key: string): string {
    return validateForm(this.form, key);
  }

  ngOnInit(): void {
    this.commentKey = this.key.toString() + "-comments";
    this.commentModel = this.model[this.commentKey] || "";
  }

  onBlurEvent(event: any) {
    this.model[this.commentKey] = event.target.value;
    this.formControl.updateValueAndValidity();
  }
}
